import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getCart } from "../api/cart";
import { useAuth } from "./AuthContext";

const CartContext = createContext(null);

/** 헤더의 장바구니 개수 배지 등에서 쓰기 위한 전역 장바구니 요약 상태. */
export function CartProvider({ children }) {
  const { auth } = useAuth();
  const [totalQty, setTotalQty] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const res = await getCart(auth?.accessToken);
      setTotalQty(res.data?.totalQty || 0);
    } catch (e) {
      setTotalQty(0);
    }
  }, [auth]);

  useEffect(() => { refresh(); }, [refresh]);

  return <CartContext.Provider value={{ totalQty, refresh }}>{children}</CartContext.Provider>;
}

export function useCartSummary() {
  const ctx = useContext(CartContext);
  if (!ctx) {
    throw new Error("useCartSummary 는 CartProvider 내부에서만 사용할 수 있습니다.");
  }
  return ctx;
}
